import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom'; // Импортируем ReactDOM для работы с порталами
import icon from '../icons.svg';

function Menu({ children, data, stl, left, bottom }) {
    const [Opened, setOpened] = useState(false);
    const [Parent, setParent] = useState(0);
    const [canClose, setClose] = useState(true);
    const node = useRef(null);
    
    // Эффект для закрытия меню по клику вне него
    useEffect(() => {
        const listener = (event) => {
            if (event.target.className === 'listfolder') setClose(false);
            // Проверяем, был ли клик внутри родительского элемента или меню
            // Обратите внимание, что это перестанет работать, если меню будет вне DOM-дерева родителя.
            // Рекомендуется использовать ref на самом меню или проверять клик вне всего компонента.
            if (node.current && node.current.contains(event.target)) return;
            // Проверка для портала: если клик был по меню, не закрываем
            const menuNode = document.getElementById('menu-portal');
            if (menuNode && menuNode.contains(event.target)) return;

            setOpened(false);
        };
        if (Opened) {
            document.addEventListener("mousedown", listener);
        }
        return () => {
            document.removeEventListener("mousedown", listener);
        };
    }, [Opened]);

    function OpenHide(e) {
        if (!Opened) {
            setOpened(true);
        } else if (canClose && Opened) {
            setOpened(false);
        }
        setClose(true);
    }

    function menuClick(act) {
        act();
    }

    function folderClick(id) {
        if (Parent === id) setParent(0);
        else setParent(id);
    }

    // eslint-disable-next-line
    const List = data.map((col, idx) => {
        let visible = 0;
        let cont = col.content || null;
        if (!col.parent) visible = 1;
        if (col.parent === Parent) visible = 2;

        if (col.icon === -1) {
            if (cont) {
                if (col.isFolder) return (<div className='listfolder' tabIndex='0' key={idx} onClick={() => { folderClick(col.id) }} onKeyUp={(e) => { if (e.key === 'Enter') folderClick(col.id) }}><div style={{ position: 'relative', display: 'inline', lineHeight: 'normal' }}>{cont}</div> {col.name}<div>&gt;</div></div>);
                else if (visible === 1) return (<div className='listitem' tabIndex='0' key={idx} onClick={() => { menuClick(col.action) }} onKeyUp={(e) => { if (e.key === 'Enter') menuClick(col.action) }}><div style={{ position: 'relative', display: 'inline', lineHeight: 'normal' }}>{cont}</div> {col.name}</div>);
                else if (visible === 2) return (<div className='listitem' tabIndex='0' key={idx} onClick={() => { menuClick(col.action) }} onKeyUp={(e) => { if (e.key === 'Enter') menuClick(col.action) }}><img src={icon + '#empty'} className='toolBarIcon' style={{ verticalAlign: 'middle' }} alt='' /> {col.name}</div>);
            }
            if (col.isFolder) return (<div className='listfolder' tabIndex='0' key={idx} onClick={() => { folderClick(col.id) }} onKeyUp={(e) => { if (e.key === 'Enter') folderClick(col.id) }}> {col.name}<div>&gt;</div></div>);
            else if (visible === 1) return (<div className='listitem' tabIndex='0' key={idx} onClick={() => { menuClick(col.action) }} onKeyUp={(e) => { if (e.key === 'Enter') menuClick(col.action) }}> {col.name}</div>);
            else if (visible === 2) return (<div className='listitem' tabIndex='0' key={idx} onClick={() => { menuClick(col.action) }} onKeyUp={(e) => { if (e.key === 'Enter') menuClick(col.action) }}><img src={icon + '#empty'} className='toolBarIcon' style={{ verticalAlign: 'middle' }} alt='' /> {col.name}</div>);
        } else {
            if (cont) {
                if (col.isFolder) return (<div className='listfolder' tabIndex='0' key={idx} onClick={() => { folderClick(col.id) }} onKeyUp={(e) => { if (e.key === 'Enter') folderClick(col.id) }}><div style={{ position: 'relative', display: 'inline', lineHeight: 'normal' }}><img src={icon + (col.icon || '#empty')} className='toolBarIcon' style={{ verticalAlign: 'middle' }} alt='' />{cont}</div> {col.name}<div>&gt;</div></div>);
                else if (visible === 1) return (<div className='listitem' tabIndex='0' key={idx} onClick={() => { menuClick(col.action) }} onKeyUp={(e) => { if (e.key === 'Enter') menuClick(col.action) }}><div style={{ position: 'relative', display: 'inline', lineHeight: 'normal' }}><img src={icon + (col.icon || '#empty')} className='toolBarIcon' style={{ verticalAlign: 'middle' }} alt='' />{cont}</div> {col.name}</div>);
                else if (visible === 2) return (<div className='listitem' tabIndex='0' key={idx} onClick={() => { menuClick(col.action) }} onKeyUp={(e) => { if (e.key === 'Enter') menuClick(col.action) }}><div style={{ position: 'relative', display: 'inline', lineHeight: 'normal' }}><img src={icon + '#empty'} className='toolBarIcon' style={{ verticalAlign: 'middle' }} alt='' /><img src={icon + (col.icon || '#empty')} className='toolBarImg' style={{ verticalAlign: 'middle' }} alt='' />{cont}</div> {col.name}</div>);
            }
            if (col.isFolder) return (<div className='listfolder' tabIndex='0' key={idx} onClick={() => { folderClick(col.id) }} onKeyUp={(e) => { if (e.key === 'Enter') folderClick(col.id) }}><img src={icon + (col.icon || '#empty')} className='toolBarIcon' style={{ verticalAlign: 'middle' }} alt='' /> {col.name}<div>&gt;</div></div>);
            else if (visible === 1) return (<div className='listitem' tabIndex='0' key={idx} onClick={() => { menuClick(col.action) }} onKeyUp={(e) => { if (e.key === 'Enter') menuClick(col.action) }}><img src={icon + (col.icon || '#empty')} className='toolBarIcon' style={{ verticalAlign: 'middle' }} alt='' /> {col.name}</div>);
            else if (visible === 2) return (<div className='listitem' tabIndex='0' key={idx} onClick={() => { menuClick(col.action) }} onKeyUp={(e) => { if (e.key === 'Enter') menuClick(col.action) }}><img src={icon + '#empty'} className='toolBarIcon' style={{ verticalAlign: 'middle' }} alt='' /><img src={icon + (col.icon || '#empty')} className='toolBarImg' style={{ verticalAlign: 'middle' }} alt='' /> {col.name}</div>);
        }
    });

    // Определение стиля для меню
    let menuStyle = {};
    if (Opened && node.current) {
        // Получаем координаты родительского элемента для позиционирования
        const rect = node.current.getBoundingClientRect();

        // Устанавливаем позиционирование относительно окна
        menuStyle.position = 'fixed';
        menuStyle.overflow = 'auto';
        menuStyle.whiteSpace = 'nowrap';
        menuStyle.fontWeight = 'normal';
        menuStyle.zIndex = 9999;

        // Логика определения top/bottom
        const windowHeight = window.innerHeight;
        const buttonBottom = rect.bottom;
        const spaceBelow = windowHeight - buttonBottom;

        if (bottom) {
            menuStyle.bottom = windowHeight - rect.top + 2;
        } else if (spaceBelow < 150 && rect.top > 150) { // Проверяем, достаточно ли места снизу
            menuStyle.bottom = windowHeight - rect.top + 2;
        } else {
            menuStyle.top = rect.bottom + 2;
        }

        // Логика определения left/right
        const windowWidth = window.innerWidth;
        const buttonLeft = rect.left;
        const spaceRight = windowWidth - buttonLeft;

        if (left) {
            menuStyle.left = buttonLeft;
        } else if (left === false) {
            menuStyle.right = windowWidth - rect.right;
        } else if (spaceRight < 150 && rect.right > 150) { // Проверяем, достаточно ли места справа
            menuStyle.right = windowWidth - rect.right;
        } else {
            menuStyle.left = buttonLeft;
        }
        
        // Дополнительная логика для высоты
        menuStyle.maxHeight = `calc(100vh - ${menuStyle.top || menuStyle.bottom}px)`;
    }

    // Создаем портал, если меню открыто
    const menuPortal = Opened ? (
        ReactDOM.createPortal(
            <div id='menu-portal' className='list' style={menuStyle}>
                {List}
            </div>,
            document.getElementById('modal-root')
        )
    ) : null;

    let style1 = { position: 'relative', height: '100%', outline: 'none' };
    if (stl) style1 = { ...style1, ...stl };

    return (
        <div ref={node} tabIndex='0' style={style1} onClick={OpenHide} onKeyUp={(e) => { if (e.key === 'Enter') OpenHide(e) }}>
            {children}
            {menuPortal}
        </div>
    );
}

export default Menu;